import styled from 'styled-components';

import ContentHeaderStyled from '../../../components/ContentHeader';
import HoverableCard from '../../../components/HoverableCard';
import PaginationStyled from '../../../components/Pagination';
import { CHART_DESCRIPTIONS } from '../chartDescriptions';

type OthersPageProps = {
  className?: string;
};

const OthersPage = ({ className = '' }: OthersPageProps) => (
  <div className={className}>
    <div className="content">
      <ContentHeaderStyled
        className="breadcrumbs"
        title="Others"
        breadcrumbs={[
          { label: 'Data Visualization', url: '/data-visualization' },
          { label: 'Others Chart' },
        ]}
      />

      <div className="cards">
        <HoverableCard
          description={CHART_DESCRIPTIONS['/data-visualization/others/bubble']}
          title="Bubbles Chart"
          url="bubble"
          image="/images/data-viz-others/bubbles.png"
          tags={['comparison']}
        />
        <HoverableCard
          description={CHART_DESCRIPTIONS['/data-visualization/others/box-plot-v']}
          title="Box Plot - V"
          url="box-plot-v"
          image="/images/data-viz-others/box-plot-v.png"
          tags={['distribution', 'comparison']}
        />

        <HoverableCard
          description={CHART_DESCRIPTIONS['/data-visualization/others/box-plot-h']}
          title="Box Plot - H"
          url="box-plot-h"
          image="/images/data-viz-others/box-plot-h.png"
          tags={['distribution', 'comparison']}
        />

        <HoverableCard
          description={CHART_DESCRIPTIONS['/data-visualization/others/violin-plot-v']}
          title="Violin Plot - V"
          url="violin-plot-v"
          image="/images/data-viz-others/violin-plot-v.png"
          tags={['distribution', 'comparison']}
        />

        <HoverableCard
          description={CHART_DESCRIPTIONS['/data-visualization/others/violin-plot-h']}
          title="Violin Plot - H"
          url="violin-plot-h"
          image="/images/data-viz-others/violin-plot-h.png"
          tags={['distribution', 'comparison']}
        />

        <HoverableCard
          description={CHART_DESCRIPTIONS['/data-visualization/others/line-and-stacked-bar']}
          title="Line & Stacked Bar Chart"
          url="line-and-stacked-bar"
          image="/images/data-viz-others/line-stacked-bar.png"
          tags={['correlation', 'comparison']}
        />

        <HoverableCard
          description={CHART_DESCRIPTIONS['/data-visualization/others/scatter-plot']}
          title="Scatter Plot"
          url="scatter-plot"
          image="/images/data-viz-others/scatter-plot.png"
          tags={['correlation']}
        />

        <HoverableCard
          description={CHART_DESCRIPTIONS['/data-visualization/others/ribbon-chart']}
          title="Ribbon Chart"
          url="ribbon-chart"
          image="/images/data-viz-others/ribbon.png"
          tags={['proportion', 'trend', 'comparison']}
        />
      </div>

      <PaginationStyled
        previousLink="/data-visualization/diagrams"
        previous="Diagrams"
        nextLink="/data-visualization/lines"
        next="Line"
        className="footer-pagination"
      />
    </div>
  </div>
);

const StyledOthersPage = styled(OthersPage)`
  > .sidebar {
    overflow-x: hidden;
    height: calc(100vh - 4rem);
  }

  > .content {
    overflow-x: hidden;
    margin: 0 auto;
    width: 100%;
    min-height: 100%;
    display: flex;
    flex-direction: column;

    > .breadcrumbs {
      margin-bottom: 24px;

      @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
        margin-bottom: 40px;
      }
    }

    > .cards {
      display: grid;
      grid-template-columns: repeat(1, 1fr);
      gap: 16px;

      @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
        grid-template-columns: repeat(2, 1fr);
        margin-bottom: 80px;
      }

      @media (min-width: ${({ theme }) => theme.breakpoints.lg}) {
        grid-template-columns: repeat(3, 1fr);
      }
    }

    > .footer-pagination {
      display: none;
      margin-top: auto;
      @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
        display: block;
      }
    }
  }
`;

export default StyledOthersPage;
